var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5306 7.28104L9.53061 19.281C9.46096 19.3508 9.37824 19.4061 9.2872 19.4438C9.19615 19.4816 9.09855 19.501 8.99999 19.501C8.90143 19.501 8.80383 19.4816 8.71278 19.4438C8.62174 19.4061 8.53902 19.3508 8.46936 19.281L3.21936 14.031C3.07863 13.8903 2.99957 13.6994 2.99957 13.5004C2.99957 13.3014 3.07863 13.1105 3.21936 12.9698C3.3601 12.8291 3.55097 12.75 3.74999 12.75C3.94901 12.75 4.13988 12.8291 4.28061 12.9698L8.99999 17.6901L20.4694 6.21979C20.6101 6.07906 20.801 6 21 6C21.199 6 21.3899 6.07906 21.5306 6.21979C21.6713 6.36052 21.7504 6.55139 21.7504 6.75042C21.7504 6.94944 21.6713 7.14031 21.5306 7.28104Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/Check-white.985eed8276429fca59b7306d6f56666f.svg";
export { ForwardRef as ReactComponent };